import { atom } from 'jotai';

import { DeviceName } from 'types/models/Robot';

import { deviceNameAtom } from './myRobot.atoms';

function throwProtectAccessError() {
  throw new Error(
    "using hook 'useMyRobot' or related atoms outside of 'LayoutRobotManagement' is not possible",
  );
}

/**
 * This get loaded in the LayoutRobotManagement witch is so high up that every selector won't get rendered before this was loaded
 * Cause the jotai root is event higher some default states are properly already set.
 * The big question is will the app still works if the change the robot from the manual control page
 * and will the app in general work properly if we change deviceName.
 *
 * Todo: Most user just fetch data - refactor this
 */
// This gets loaded in the LayoutRobotManagement witch is so high up that every selector won't get rendered before this was loaded
export const deviceNameSelector = atom((get) => {
  const deviceName = get(deviceNameAtom);
  if (!deviceName) throwProtectAccessError();

  return deviceName as DeviceName;
});
deviceNameSelector.debugLabel = 'My Robot/Device Name Selector (atom)';
